var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPptx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000132072199401363406060000000550315028137973144_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PPTX"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m463.6 141.4v308.9c0 34.1-27.6 61.7-61.7 61.7h-244.8c-34.1 0-61.7-27.6-61.7-61.7v-388.6c-.1-34.1 27.6-61.7 61.7-61.7h165.1z",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m463.6 141.4h-115.9c-14.1 0-25.5-11.4-25.5-25.5v-115.9z",
    fill: "#f15642"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.2 210.7h306.3c20.9 0 37.8 16.9 37.8 37.8v92c0 20.9-16.9 37.8-37.8 37.8h-306.3c-20.9 0-37.8-16.9-37.8-37.8v-92c0-20.9 16.9-37.8 37.8-37.8z",
    fill: "#f15642"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m168 276c0 21.3-11.3 33.1-31.2 33.1h-12.2v35.7h-14.6v-101.6h26.8c19.9 0 31.2 12.1 31.2 32.8zm-14.9 0c0-12.5-5.4-18.9-16.4-18.9h-12v38h12c11 .1 16.4-6 16.4-19.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m238.5 276c0 21.3-11.3 33.1-31.2 33.1h-12.2v35.7h-14.6v-101.6h26.8c19.9 0 31.2 12.1 31.2 32.8zm-14.9 0c0-12.5-5.4-18.9-16.4-18.9h-12v38h12c11 .1 16.4-6 16.4-19.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m300.9 257.2h-21.2v87.6h-14.9v-87.6h-21v-13.9h57.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m353.8 344.8-16-37.6-16.1 37.6h-16.2l24.2-52.6-22.8-48.9h16.1l14.8 34.4 14.6-34.4h16.1l-22.8 48.9 24.2 52.6z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPptx);
export default __webpack_public_path__ + "static/media/pptx.9cb67c7d4c866917db76b369b1ef1262.svg";
export { ForwardRef as ReactComponent };